var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-component"},[_c('router-link',{attrs:{"to":{ name: 'bitcoin' }}},[_c('ct-banner',{attrs:{"banner":_vm.banner}})],1),_c('ct-about-content'),_c('ct-newsletter',{attrs:{"title":"Quer receber notícias da pague?"}}),_c('ct-depositions',{attrs:{"depositions":_vm.depositions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }